import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Users, Plus, ArrowLeft } from "@phosphor-icons/react";

export default function Community() {
  const [groups, setGroups] = useState([]);
  const [active, setActive] = useState(null);
  const [posts, setPosts] = useState([]);
  const [body, setBody] = useState("");
  const [anon, setAnon] = useState(false);

  useEffect(() => { api.get("/community/groups").then((r) => setGroups(r.data)); }, []);

  const open = async (g) => {
    setActive(g);
    const r = await api.get(`/community/groups/${g.id}/posts`);
    setPosts(r.data);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!body.trim() || !active) return;
    try {
      await api.post("/community/post", { group_id: active.id, body, anonymous: anon });
      setBody("");
      const r = await api.get(`/community/groups/${active.id}/posts`);
      setPosts(r.data);
    } catch { toast.error("Could not post."); }
  };

  const del = async (id) => { await api.delete(`/community/post/${id}`); if (active) { const r = await api.get(`/community/groups/${active.id}/posts`); setPosts(r.data); } };

  if (active) {
    return (
      <div className="space-y-6 max-w-2xl mx-auto" data-testid="community-group-page">
        <button onClick={() => setActive(null)} className="inline-flex items-center gap-2 text-sm text-ink-700 hover:text-ink-900" data-testid="community-back"><ArrowLeft weight="thin" size={16} /> All groups</button>
        <header>
          <p className="overline text-saffron mb-2">{active.kind}</p>
          <h1 className="font-serif text-4xl">{active.name}</h1>
          <p className="text-ink-700 mt-1">{active.description}</p>
        </header>
        <form onSubmit={submit} className="vansha-card p-5" data-testid="community-composer">
          <textarea value={body} onChange={(e) => setBody(e.target.value)} className="input-line font-serif text-lg" rows="3" placeholder="Share your story or ask a question…" data-testid="community-body" />
          <div className="flex justify-between items-center mt-3">
            <label className="flex items-center gap-2 text-sm text-ink-700"><input type="checkbox" checked={anon} onChange={(e) => setAnon(e.target.checked)} data-testid="anon-toggle" /> Post anonymously</label>
            <button className="btn-primary" disabled={!body.trim()} data-testid="community-post">Share</button>
          </div>
        </form>
        {posts.length === 0 ? (
          <p className="text-ink-500" data-testid="community-empty">No posts yet. Be the first.</p>
        ) : (
          <div className="space-y-3">
            {posts.map((p) => (
              <div key={p.id} className="vansha-card p-5" data-testid={`cm-post-${p.id}`}>
                <p className="font-serif text-lg">{p.author_name}</p>
                <p className="overline">{new Date(p.created_at).toLocaleDateString()}</p>
                <p className="text-ink-900 mt-2 whitespace-pre-wrap">{p.body}</p>
                <button onClick={() => del(p.id)} className="text-xs text-ink-500 mt-3 hover:text-terracotta">Remove (if mine)</button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-8" data-testid="community-page">
      <header>
        <p className="overline text-saffron mb-2">Community</p>
        <h1 className="font-serif font-semibold text-4xl sm:text-5xl">Not alone.</h1>
        <p className="text-ink-700 mt-2">Private, moderated groups for every chapter of your journey.</p>
      </header>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {groups.map((g) => (
          <button key={g.id} onClick={() => open(g)} className="vansha-card p-6 text-left hover:shadow-lg transition" data-testid={`group-${g.id}`}>
            <Users weight="thin" size={28} className="text-terracotta mb-3" />
            <h3 className="font-serif text-2xl">{g.name}</h3>
            <p className="text-ink-700 mt-2 text-sm">{g.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
